export const appRoutes = {
    onboarding: '/onboarding',
    home: '/home', // Dashboard Personal — primary landing
    leaderboard: '/leaderboard',
    procedures: '/procedures',
    history: '/history',
    scheduler: '/scheduler',
    calendar: '/calendar',
    suggestions: '/sugestii',
    cockpit: '/admin/cockpit',
    archive: '/arhiva',
}

export function isKnownAppPath(pathname) {
    if (!pathname) return false

    if (pathname === '/' || pathname === appRoutes.onboarding) return true
    if (pathname === appRoutes.home) return true
    if (pathname === appRoutes.leaderboard) return true
    if (pathname === appRoutes.procedures || pathname === appRoutes.history) return true
    if (pathname === appRoutes.scheduler) return true
    if (pathname === appRoutes.calendar) return true
    if (pathname === appRoutes.suggestions) return true
    if (pathname === appRoutes.cockpit) return true
    if (pathname === appRoutes.archive) return true

    return false
}

export function buildSearch(searchParams, updates = {}, removals = []) {
    const next = new URLSearchParams(searchParams)

    removals.forEach((key) => next.delete(key))
    Object.entries(updates).forEach(([key, value]) => {
        if (value === null || value === undefined || value === '') {
            next.delete(key)
            return
        }
        next.set(key, value)
    })

    const query = next.toString()
    return query ? `?${query}` : ''
}
